import {
  blackColor,
  dangerColor,
  grayColor,
  hexToRgb,
  infoColor,
  primaryColor,
  successColor,
  warningColor,
  whiteColor,
} from '../../../materialUI/jss/material-dashboard-pro-react.js'

const bookingSummaryStyles = {
  rootBackground: (theme) => ({
    backgroundImage:
      'linear-gradient(rgb(' +
      hexToRgb(theme.components.bookingSummary.backgroundImage) +
      '), rgb(' +
      hexToRgb(theme.components.bookingSummary.backgroundImage) +
      '))',
    minWidth: '300px',
    maxWidth: '450px',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: '8px',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
  }),
  containerDiv: {
    padding: 'var(--sp-6, 24px)',
  },
  summaryLabel: {
    textTransform: 'uppercase',
    color: 'var(--jy-amber-500, #f4a94a)',
    fontSize: 'var(--fs-12, 0.75rem)',
    letterSpacing: 'var(--tracking-caps, 0.14em)',
    fontWeight: 600,
  },
  summaryValue: {
    fontSize: 'var(--fs-14, 0.875rem)',
    fontFamily: 'var(--font-sans, "Inter", sans-serif)',
    fontWeight: 400,
  },
  summaryValueRequired: {
    fontSize: 'var(--fs-14, 0.875rem)',
    color: '#ffffff',
    fontFamily: 'var(--font-sans, "Inter", sans-serif)',
    fontWeight: 400,
    opacity: 0.5,
  },
  summaryIcon: {
    fontSize: '24px',
    color: 'var(--jy-navy-900, #00253d)',
    background: 'var(--jy-amber-500, #f4a94a)',
    padding: '4.5px',
    borderRadius: '50%',
  },
  summaryIconNoData: {
    fontSize: '24px',
    color: 'var(--jy-navy-900, #00253d)',
    background: 'var(--jy-amber-500, #f4a94a)',
    padding: '4.5px',
    borderRadius: '50%',
    opacity: '0.2',
  },
  summaryIconCell: {
    verticalAlign: 'top',
    paddingRight: 'var(--sp-4, 16px)',
    paddingTop: 'var(--sp-1, 4px)',
  },
  wizardContainer: {},
  card: {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: 'var(--sp-6, 24px) 0',
    boxShadow: 'var(--shadow-sm, 0 2px 6px rgba(10, 37, 61, 0.08))',
    borderRadius: 'var(--r-lg, 14px)',
    color: 'var(--color-text, #0d1418)',
    background: 'var(--color-surface, #fff)',
    transition: 'all 220ms cubic-bezier(0.2, 0.8, 0.2, 1)',
    minHeight: '410px',
    minWidth: '500px',
  },
  wizardHeader: {
    textAlign: 'center',
    padding: 'var(--sp-6, 24px) 0 var(--sp-2, 8px)',
  },
  title: {
    margin: '0',
  },
  subtitle: {
    margin: 'var(--sp-1, 4px) 0 0',
  },
  wizardNavigation: {
    position: 'relative',
  },
  nav: {
    marginTop: '20px',
    paddingLeft: '0',
    marginBottom: '0',
    listStyle: 'none',
    backgroundColor: 'rgba(' + hexToRgb(grayColor[17]) + ', 0.2)',
    '&:after,&:before': {
      display: 'table',
      content: '" "',
    },
    '&:after': {
      boxSizing: 'border-box',
    },
  },
  steps: {
    marginLeft: '0',
    textAlign: 'center',
    // float: "left",
    // display: "block",
    position: 'relative',
    display: 'inline-block',
  },
  stepsAnchor: {
    cursor: 'pointer',
    position: 'relative',
    display: 'block',
    padding: '10px 15px',
    textDecoration: 'none',
    transition: 'all .3s',
    border: '0 !important',
    borderRadius: '30px',
    lineHeight: '18px',
    textTransform: 'uppercase',
    fontSize: '12px',
    fontWeight: '500',
    minWidth: '100px',
    textAlign: 'center',
    color: grayColor[6] + ' !important',
  },
  content: {
    marginTop: '20px',
    minHeight: '340px',
    padding: '20px 15px',
  },
  stepContent: {
    display: 'none',
  },
  stepContentActive: {
    display: 'block',
  },
  movingTab: {
    position: 'absolute',
    textAlign: 'center',
    padding: '12px',
    fontSize: '12px',
    textTransform: 'uppercase',
    WebkitFontSmoothing: 'subpixel-antialiased',
    top: '-4px',
    left: '0px',
    borderRadius: '4px',
    color: whiteColor,
    cursor: 'pointer',
    fontWeight: '500',
  },
  primary: {
    backgroundColor: primaryColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(primaryColor[0]) +
      ', 0.4)',
  },
  warning: {
    backgroundColor: warningColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(warningColor[0]) +
      ', 0.4)',
  },
  danger: {
    backgroundColor: dangerColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(dangerColor[0]) +
      ', 0.4)',
  },
  success: {
    backgroundColor: successColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(successColor[0]) +
      ', 0.4)',
  },
  info: {
    backgroundColor: infoColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(infoColor[0]) +
      ', 0.4)',
  },
  rose: (theme) => ({
    backgroundColor: theme.palette.rose['200'],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(theme.palette.rose['200']) +
      ', 0.4)',
  }),
  footer: {
    padding: '0 15px',
  },
  left: {
    float: 'left!important',
  },
  right: {
    float: 'right!important',
  },
  clearfix: {
    '&:after,&:before': {
      display: 'table',
      content: '" "',
    },
    clear: 'both',
  },
  wizardPage: {
    width: '100%',
  },
}

export default bookingSummaryStyles
